
/**
 * Created by Wojciech Szydlak on 14.01.2018.
 */

namespace Action.ContextMenu {
    export class MapSetGpsClientService extends Action.ContextMenu.MapSetGpsClient {
        public execute(): void {
            return this.executeFor(
                Action.ContextMenu.MapSetGpsClient.setGpsFor.clientService,
                this.event.target.urlParams[URICenterParser.GET_PRAM_NAME_CLIENT_SERVICE_ID],
                ({lat, lng}) => {
                    let app = App.getInstance();
                    let serviceId = this.event.target.urlParams[URICenterParser.GET_PRAM_NAME_CLIENT_SERVICE_ID];
                    let client = app.entityContainer.findClientByServiceId(serviceId);
                    this.updateMarker(client, lat, lng);
                }
            );
        }
    }
}
